export const classicData = [
  {
    name: "Массаж воротниковой зоны (20 минут)",
    price: "1200 ₽",
  },
  {
    name: "Массаж воротниковой зоны+верхних конечностей (30минут)",
    price: "1700 ₽",
  },
  {
    name: "Массаж шейно-грудного отдела (30минут)",
    price: "1700 ₽",
  },
  {
    name: "Массаж пояснично-крестцовой зоны + ягодицы (30 минут)",
    price: "1700 ₽",
  },
  {
    name: "Массаж пояснично-крестцовой зоны+ягодицы+нижних конечностей (50минут)",
    price: "2000 ₽",
  },
  {
    name: "Массаж всех отделов позвоночника (40минут)",
    price: "2000 ₽",
  },
  {
    name: "Общий массаж тела (1час 20минут)",
    price: "3000 ₽",
  },
  {
    name: "Массаж всех отделов позвоночника + ягодичная область (50минут)",
    price: "2300 ₽",
  },
  {
    name: "Релаксирующий английский массаж по аромамаслу (1час 30минут)",
    price: "3000 ₽",
  },
  {
    name: "Подводный общеоздоровительный массаж (25минут)",
    price: "1000 ₽",
  },
  {
    name: "Кедровая фито-бочка",
    price: "1000 ₽",
  },
];
